// SimilarRoles.tsx
import React from "react";
import Link from "next/link";
import styles from "./SimilarRoles.module.css";

interface Banner {
  id: number;
  title: string;
  description: string;
  desktop_img: {
    url: string;
  };
  mobile_img: {
    url: string;
  };
}
interface CareerData {
  id: number;
  category: string;
  banner: Banner;
  slug: string;
}
interface SimilarRolesProps {
  data: CareerData[];
}

const SimilarRoles: React.FC<SimilarRolesProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Similar Roles</h2>
      <ul className={styles.roleList}>
        {data?.map((role, index) => (
          <li key={index} className={styles.roleItem}>
            <Link href={role.slug}>
              <h3 className={styles.roleTitle}>{role?.banner?.title}</h3>
              <p className={styles.roleDescription}>
                {role?.banner?.description}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SimilarRoles;
